import * as types from './types';

export const taraSetHasMadeIntroduction = hasMadeIntroduction => ({
  type: types.TARA_SET_HAS_MADE_INTRODUCTION,
  payload: {
    hasMadeIntroduction,
  },
});

export const taraSetHasCuratedTickets = hasCuratedTickets => ({
  type: types.TARA_SET_HAS_CURATED_TICKETS,
  payload: {
    hasCuratedTickets,
  },
});

export const taraSetIsViewingSurvey = isViewingSurvey => ({
  type: types.TARA_SET_IS_VIEWING_SURVEY,
  payload: {
    isViewingSurvey,
  },
});

export const taraSetSurveyCompleted = surveyCompleted => ({
  type: types.TARA_SET_SURVEY_COMPLETED,
  payload: {
    surveyCompleted,
  },
});

export const taraGetSurveyRequest = survey => ({
  type: types.TARA_GET_SURVEY.REQUEST,
  payload: {
    survey,
  },
});

export const taraPostSurveyRequest = form => ({
  type: types.TARA_POST_SURVEY.REQUEST,
  payload: form,
});



// WEBPACK FOOTER //
// ./src/actions/tara/actions.js